export const DATA_LOAD_ERROR_COPY = {
  TITLE: "Couldn't load data",
  MESSAGE: 'Check your connection and try again.',
  RETRY: 'Try again',
} as const

export const OFFLINE_BANNER_COPY = {
  MESSAGE: "You're offline. Some data may be outdated.",
} as const

export const ARENA_CHALLENGES_ERROR_COPY = {
  TITLE: "Couldn't load challenges",
  MESSAGE: 'Pull to refresh or tap Try again.',
} as const

export const SCOREBOARD_ERROR_COPY = {
  TITLE: "Couldn't load scoreboard",
  MESSAGE: 'Check your connection and try again.',
} as const

export const FRIENDS_ERROR_COPY = {
  TITLE: "Couldn't load friends",
  MESSAGE: 'Check your connection and try again.',
} as const

export const ARENA_STATS_ERROR_COPY = {
  TITLE: "Couldn't load arena stats",
  MESSAGE: 'Tap Try again to reload your record.',
} as const
